import { useProductDescription } from '../hooks/useProductDescription';

const ProductDescriptionTitle = () => {
	const { blockClass, title, showTitle = true } = useProductDescription();

	const renderClass = () => {
		return (
			blockClass &&
			`productDescriptionTitle--${blockClass} vtex-store-components-3-x-productDescriptionTitle--${blockClass}`
		);
	};

	if (!showTitle) {
		return <></>;
	}

	return (
		<h2
			className={`productDescriptionTitle vtex-store-components-3-x-productDescriptionTitle ${renderClass()} t-heading-5 mb5 mt0`}
		>
			{title || 'Descrição do produto'}
		</h2>
	);
};

export default ProductDescriptionTitle;
